"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getWatchedValues = getWatchedValues;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _getValues = require("../get-values");
var _getValuesWithNames = require("../get-values-with-names");
function getWatchedValues(formElement, inputStates, inputNames) {
  if (!formElement) {
    return typeof inputNames === 'string' ? '' : {};
  }
  const values = (0, _isArray.default)(inputNames) ? (0, _getValuesWithNames.getValuesWithNames)(formElement, inputStates, inputNames) : (0, _getValues.getValues)(formElement, inputStates);
  return typeof inputNames === 'string' ? values[inputNames] : values;
}